import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LoginForm } from "@/components/login-form";

const searchSchema = z.object({
  reason: z.enum(["session_expired"]).optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: searchSchema,
  head: () => ({
    meta: [
      { title: "Sign in — ProcureFlow" },
      { name: "description", content: "Sign in to ProcureFlow." },
    ],
  }),
  component: LoginRoute,
});

function LoginRoute() {
  const { reason } = Route.useSearch();
  return <LoginForm reason={reason} />;
}
